import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AUTH_QUERY_KEYS, AUTH_ROUTES } from '../constants';
import { authService } from '../services';
import { useAuthStore } from './use-auth-store';

/** As contas com sessao viva neste navegador - trocar para elas nao pede senha. */
export function useConnectedAccounts() {
  return useQuery({
    queryKey: [...AUTH_QUERY_KEYS.me, 'accounts'],
    queryFn: () => authService.connectedAccounts(),
    // A modal de trocar so abre de vez em quando: vale a pena confirmar de
    // novo com o servidor em vez de mostrar um selo [conectada] que ja caiu.
    refetchOnMount: 'always',
  });
}

export function useSwitchAccount() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setUser = useAuthStore((state) => state.setUser);

  return useMutation({
    mutationFn: (userId: string) => authService.switchAccount(userId),

    onSuccess: async (resposta) => {
      setUser(resposta.user);
      // Sair da tela antes de recarregar: a pagina da conta anterior podia
      // nao ser permitida na nova, e o refetch voltava so 403.
      navigate(AUTH_ROUTES.DASHBOARD, { replace: true });
      await queryClient.resetQueries();
    },
  });
}
